export default "__VITE_ASSET__DfMSdV1q__"